export default function (groups) {
	return {
		groups,
		searchQuery: null,
		openLetters: [],
		collapsedCount: 5,

		matches(name) {
			if (!this.searchQuery) {
				return true
			}

			return name.toLowerCase().includes(this.searchQuery.toLowerCase())
		},

		showBrand(letter, index) {
			if (this.searchQuery) {
				return this.matches(this.groups[letter][index])
			}

			return index < this.collapsedCount || this.letterIsOpen(letter)
		},

		showLetter(letter) {
			if (!this.searchQuery) {
				return true
			}

			return this.groups[letter].some(name => this.matches(name))
		},

		letterIsOpen(letter) {
			return this.openLetters.includes(letter)
		},

		openLetter(letter) {
			this.openLetters.push(letter)
		},

		closeLetter(letter) {
			this.openLetters = this.openLetters.filter(openLetter => openLetter !== letter)
		},
	}
}
